import React from "react";
import { Link } from "react-router-dom";
import { db } from "../Components/Firebase";
import { collection, getDocs, orderBy, query } from "firebase/firestore";
import decimg from "../Pages/mailicon.png"

function oddEven(index) {
    if (index % 2 === 0){
        return "blogli";
    }
    else{
        return "blogli-alt";
    }
}

function GetPosts() {
    //States for the firestore documents
    const [items, setItems] = React.useState([]);
    const [ids, setIds] = React.useState([]);

    React.useEffect(() => {
		const fetchItems = async () => {
			const q = query(collection(db, "Posts"), orderBy("Time", "desc"));
			const querySnapshot = await getDocs(q);
			setItems(querySnapshot.docs.map((doc) => doc.data()));
            setIds(querySnapshot.docs.map((doc) => doc.id));
		};
		fetchItems();
	}, []);

    return (
        <div>
            {items.map((item, index) => (
                <Link to={`/post/${ids[index]}`} key={index}>
                <div className="blogitembox">
                        <img src={decimg} className="blogdecorator" alt="decorator"></img>
                    <div className={oddEven(index)}>
                        
                            <div className = "blogdate">{(item.Time) ? item.Time.toDate().toDateString() : "Date Unknown"}:</div>
                            <span className="bloglink">
                            {item.Title}
                            </span>
    
                    </div>
                </div>
                </Link>
            ))}
        </div>
    )
}

export default GetPosts;
